import e, { memo as D, useId as F } from "react";
import { useTheme as P, Modal as S, ModalOverlay as _, ModalContent as j, ModalBody as G, Flex as O, Text as o, Heading as q } from "@chakra-ui/react";
import { RichTextRenderer as J } from "../../atoms/rich-text-renderer/rich-text-renderer.js";
import { ModalHeader as K } from "./modal-header.js";
import { ModalFooter as N } from "./modal-footer.js";
const Q = (a) => typeof a == "object" ? /* @__PURE__ */ e.createElement(J, { content: a }) : a, A = D(
  ({
    contentTitle: a,
    modalTitle: f,
    contentSubtitle: l,
    modalSupertext: r,
    contentText: m,
    callToAction1: s,
    callToAction2: c,
    isOpen: p,
    onClose: n,
    children: x,
    isFooterCentered: E,
    ctaClickHandler: M,
    size: i = "medium"
  }) => {
    const {
      text: { deemphasized: R, default: d },
      modalsItemHeaderBold: k,
      modalsItemHeaderRegular: u,
      modalsTitle: B,
      interactive: t,
      surface: w,
      modalsMediumContentSpacing: C,
      modalsSmall: H,
      modalsMedium: I,
      modalsLarge: y,
      modalsExtraLarge: v,
      modalsBorderRadius: b,
      modalsBorderRadiusSheet: L,
      modalsDefaultPadding: T,
      modalsSmallPadding: W,
      scrollbar: { verticalWidth: h, borderRadius: g }
    } = P(), $ = {
      small: H,
      medium: I,
      large: y,
      extraLarge: v
    }, z = F();
    return /* @__PURE__ */ e.createElement(
      S,
      {
        isOpen: p,
        onClose: n,
        scrollBehavior: "inside",
        "data-testid": "modal"
      },
      /* @__PURE__ */ e.createElement(_, null),
      /* @__PURE__ */ e.createElement(
        j,
        {
          borderRadius: {
            base: L,
            sm: b
          },
          borderBottomRadius: {
            base: "0",
            sm: b
          },
          mx: W,
          mt: "auto",
          mb: {
            base: "0",
            sm: "auto"
          },
          p: T,
          maxW: {
            base: "100%",
            sm: $[i]
          },
          maxH: {
            base: "90vh",
            sm: i === "small" ? "50vh" : "80vh"
          },
          backgroundColor: w.default
        },
        /* @__PURE__ */ e.createElement(K, { modalTitle: f }),
        /* @__PURE__ */ e.createElement(
          G,
          {
            "aria-labelledby": `chakra-modal--header-${z}`,
            tabIndex: 0,
            role: "region",
            sx: {
              "&::-webkit-scrollbar": {
                width: h,
                borderRadius: g,
                backgroundColor: t == null ? void 0 : t.backgroundDefault
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: t == null ? void 0 : t.deemphasized,
                borderRadius: g
              }
            },
            width: `calc(100% - ${h})`
          },
          /* @__PURE__ */ e.createElement(O, { direction: "column", rowGap: C }, r && /* @__PURE__ */ e.createElement(
            o,
            {
              "data-testid": "modal-supertext",
              color: d,
              ...k
            },
            r
          ), a && /* @__PURE__ */ e.createElement(
            q,
            {
              "data-testid": "modal-content-title",
              as: "h2",
              color: d,
              ...B
            },
            a
          ), l && /* @__PURE__ */ e.createElement(
            o,
            {
              "data-testid": "modal-subtitle",
              color: R,
              ...u
            },
            l
          ), m && /* @__PURE__ */ e.createElement(
            o,
            {
              "data-testid": "modal-content-text",
              color: d,
              ...u
            },
            Q(m)
          ), x)
        ),
        (s || c) && /* @__PURE__ */ e.createElement(
          N,
          {
            callToAction1: s,
            callToAction2: c,
            onClose: n,
            ctaClickHandler: M,
            centered: E
          }
        )
      )
    );
  }
);
export {
  A as Modal
};
